<template>
    <div>
        <div class="flex items-center space-x-2">
            <button
                class="button-text button-info disabled:opacity-50 disabled:cursor-not-allowed"
                :disabled="confirmedGuestsCount === 0"
                @click="isModalOpen = true"
            >
                Export PDF file
            </button>
        </div>

        <export-badges-modal v-model="isModalOpen"></export-badges-modal>
    </div>
</template>

<script>
import { get } from 'vuex-pathify';
import ExportBadgesModal from '@/components/core/ExportBadgesModal.vue';

export default {
    components: { ExportBadgesModal },

    props: {
        confirmedGuestsCount: {
            type: Number,
            required: true
        }
    },

    data () {
        return {
            isModalOpen: false
        };
    },

    computed: {
        event: get('Event/event')
    }
};
</script>
